import { useMsal } from '@azure/msal-react';
import { getCurrentUser } from './currentUser';

export function useCurrentUser() {
    const { accounts } = useMsal();
    // Keep identity and token acquisition aligned with the portal's primary-account convention.
    return getCurrentUser(accounts[0]);
}
